import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import translate from "@insite/client-framework/Translate";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { sharedStyled } from "@store/Components/Customer/CommonStyle";
import CustomerSearchField from "@store/Components/Customer/CustomerSearchField";
import CustomerTable from "@store/Components/Customer/CustomerTable";
import PaginationCustomer from "@store/Components/Utils/PaginationCustomer";
import React, { useState } from "react";

interface OwnProps {
    selectCustomerHandler: Function;
    currentShipTo: string;
    shipTosDataView: any;
    setParameter: (parameter: GetShipTosApiParameter) => void;
    parameter: GetShipTosApiParameter;
}

export interface BillToSelectionStyles {
    selectorDynamicDropdown?: InjectableCss;
    tableHead?: DataTableHeadProps;
    customerRow?: DataTableRowProps;
    selectionTitle?: TypographyProps;
    searchGridItem?: GridItemProps;
    customerTableColHeader?: DataTableHeaderProps;
    radioRowHeader?: DataTableHeaderProps;
    addressTableColHeader?: DataTableHeaderProps;
    idRowHeader?: DataTableHeaderProps;
    cityTableColheader?: DataTableHeaderProps;
    table?: DataTableProps;
    contentWrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    container?: GridContainerProps;
}

export const billToSelectionStyles: BillToSelectionStyles = {
    ...sharedStyled,
};

const styles = billToSelectionStyles;

const ShipToSelection = ({
    selectCustomerHandler,
    currentShipTo,
    shipTosDataView,
    setParameter,
    parameter,
}: OwnProps) => {
    const { value } = shipTosDataView;

    if (!value) {
        return null;
    }

    return (
        <StyledWrapper {...styles.contentWrapper}>
            <StyledWrapper {...styles.tableWrapper}>
                <CustomerTable
                    currentItems={value}
                    styles={styles}
                    currentShipTo={currentShipTo}
                    selectCustomerHandler={selectCustomerHandler}
                    isShipTo={true}
                />
            </StyledWrapper>
            <PaginationCustomer dataView={shipTosDataView} setParameter={setParameter} parameter={parameter} />
        </StyledWrapper>
    );
};

export default ShipToSelection;
